/**
 * @generated SignedSource<<438dea955409d6b1b3526df755b1100c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedNewArrivalsModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_viewer">;
  readonly " $fragmentType": "HpSharedNewArrivalsModule_viewer";
};
export type HpSharedNewArrivalsModule_viewer$key = {
  readonly " $data"?: HpSharedNewArrivalsModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedNewArrivalsModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedNewArrivalsModule_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2d1e8a18647e7fec598e3b9588cdcfe1";

export default node;
